import { FormErrorMessage, type FormErrorMessageProps } from '@chakra-ui/react';

export type UiFormErrorMessageProps = FormErrorMessageProps;

export const UiFormErrorMessage = FormErrorMessage;
